import React from "react";
import PropTypes from "prop-types";
import utils from "../utils";

import "css/DimensionSummary.css";

const propTypes = {
    width: PropTypes.number.isRequired,
    height:PropTypes.number.isRequired,
    unit:PropTypes.string.isRequired
};

const DimensionSummary = ({ width, height, unit, isConservatory }) => 
    <div className="dimension-summary">
        <span>Width:</span>
        <span>{unit === "ft" ? utils.percentFormatter(width, unit) : utils.formatNumber(width) + " " + unit}</span>
        <span> {isConservatory ? "Projection:": "Height:"}</span>
        <span>{unit === "ft" ? utils.percentFormatter(height, unit) : utils.formatNumber(height) + " " + unit}</span>
    </div>;

DimensionSummary.propTypes = propTypes;

DimensionSummary.defaultProps = {};

export default DimensionSummary;


// WEBPACK FOOTER //
// ./src/components/DimensionSummary.js